import React from "react";

const LeaveApplication = ({ data }) => {
  const { leave_application = [], leave_balance = {} } = data || {};

  return (
    <>
      <div className="row">
        <div className="col-md-6 offset-3">
          {/* Leave Balance Section */}
          <table className="table table-sm table-hover table-striped align-items-center justify-content-center mb-5">
            <thead>
              <tr>
                <th colSpan={2} className="text-center">
                  Leave Balance
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Casual</th>
                <td>{leave_balance.casual}</td>
              </tr>
              <tr>
                <th>Sick</th>
                <td>{leave_balance.sick}</td>
              </tr>
              {/* <tr>
                <th>Earn</th>
                <td>{leave_balance.earn}</td>
              </tr>
              <tr>
                <th>Others</th>
                <td>{leave_balance.others}</td>
              </tr> */}
            </tbody>
          </table>
        </div>

        {/* Leave Application Section */}
        <div className="col-md-12">
          <div className="table-responsive p-0 pb-2">
            <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
              <thead>
                <tr>
                  <th colSpan={9} className="text-center">
                    Application
                    <hr />
                  </th>
                </tr>
                <tr>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    S/N
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Name
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Apply Date
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Start Date
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    End Date
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Total Days
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Leave Type
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Status
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Created At
                  </th>
                </tr>
              </thead>

              <tbody>
                {leave_application.length > 0 ? (
                  leave_application.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-xs">{index + 1}</td>
                      <td className="text-xs">{item.staff?.name}</td>
                      <td className="text-xs">{item.application_date}</td>
                      <td className="text-xs">{item.start_date}</td>
                      <td className="text-xs">{item.end_date}</td>
                      <td className="text-xs">{item.total_days}</td>
                      <td className="text-xs">{item.leave_type}</td>
                      <td className="text-xs">{item.status}</td>
                      <td className="text-xs">{item.created_at}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted">
                      No Leave Applications Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveApplication;
